
interface SignInFormProps {
  toggleForm: () => void;
  initialEmail?: string;
}
export function SignInForm({ toggleForm, initialEmail }: SignInFormProps) {
  return (
    <>
      <div class="text-center mb-8">
        <h2 class="text-3xl font-black text-white mb-2">Welcome Back</h2>
        <p class="text-gray-400 text-sm">Please enter your details to sign in.</p>
      </div>

      <form method="POST" class="space-y-5">
        <input type="hidden" name="formType" value="signin" />
        <div>
          <label class="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 ml-1">
            Email
          </label>
          <input
            name="email"
            type="email"
            required
            autofocus
            placeholder="name@example.com"
            value={initialEmail || ""}
            class="w-full px-5 py-4 bg-gray-900/50 border border-white/5 rounded-2xl text-white placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-accent/50 focus:border-accent/50 transition-all duration-300"
          />
        </div>
        <div>
          <label class="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 ml-1">
            Password
          </label>
          <input
            type="password"
            name="password"
            required
            placeholder="••••••••"
            class="w-full px-5 py-4 bg-gray-900/50 border border-white/5 rounded-2xl text-white placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-accent/50 focus:border-accent/50 transition-all duration-300"
          />
        </div>

        <div class="flex justify-end">
          <button
            type="button"
            onClick={toggleForm}
            class="text-xs font-bold text-accent hover:text-yellow-200 text-yellow-500 transition-colors"
          >
            Forgot password?
          </button>
        </div>

        <button
          type="submit"
          class="w-full bg-accent hover:bg-yellow-500 text-black font-bold py-4 px-6 rounded-2xl shadow-lg shadow-accent/20 transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] mt-2"
        >
          Sign In
        </button>
      </form>
    </>
  );
}